import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    stack: String
  }

  connect() {
    this.element.addEventListener("image-selection-limit:clear", this.clear.bind(this))
  }

  clear() {
    window.helpers.clearStack(this.stackValue, {
    notifyCallbacks: false,
    keepPrimary: false
    })
  }
}
